import cx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { InputStyleProps } from '../types';

import classes from './NumberInput.module.css';

export const NumberInputOverrideClassNames = (props: InputStyleProps) => {
  const { size, focussed, error, rightSection } = props;

  return {
    ...InputOverrideClassNames({ size, focussed, error, rightSection }),
    control: cx(classes.control, {
      [classes.textFocused]: !error && focussed,
      [classes.textError]: error
    }),
    currencyLabel: classes.currencyLabel,
    sectionWithCurrency: classes.sectionWithCurrency,
    sectionWithCurrencySmall: classes.sectionWithCurrencySmall
  };
};
